module.exports = __webpack_public_path__ + "img/pa.2827f6a5.svg";